import { canViewAdmin } from "./domain";
import { demoData } from "./demoData";
import type { LexData, User } from "./types";

export const demoViewerStorageKey = "lexmosaic.demoViewerId";

export function demoDataForViewer(viewerId?: string | null): LexData {
  const viewer = demoData.users.find((user) => user.id === viewerId) ?? demoData.viewer;
  return {
    ...demoData,
    viewer,
    viewerFirm: viewer.firmId ? demoData.firms.find((firm) => firm.id === viewer.firmId) ?? null : null,
  };
}

export function getDefaultAdminDemoUser(data: Pick<LexData, "users"> = demoData): User | null {
  return data.users.find((user) => canViewAdmin(user)) ?? null;
}

export function getDefaultMemberDemoUser(data: Pick<LexData, "users"> = demoData): User | null {
  return data.users.find((user) => user.id === demoData.viewer.id) ?? data.users.find((user) => !canViewAdmin(user)) ?? null;
}

export function readDemoViewerId() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(demoViewerStorageKey);
}

export function setDemoViewerId(userId: string) {
  window.localStorage.setItem(demoViewerStorageKey, userId);
}

export function resetDemoViewerId() {
  window.localStorage.removeItem(demoViewerStorageKey);
}
